import EmptyImage from "assets/images/svg/activity-empty.svg";

function ActivityEmpty() {
  return (
    <div className="activity-empty-state">
      <span>
        <img src={EmptyImage} alt="image" />
      </span>
      <span className="mt-2 font-title-normal fw-600 leading-2">
        Activity log
      </span>
      <p className="font-body-normal leading-2">
        Your recent actions and updates will appear here once available.
      </p>
    </div>
  );
}

export default ActivityEmpty;
